import { FC, ReactNode } from 'react'
import styled from 'styled-components'

import Emoji from '../display/Emoji'

const IconographyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  font-size: ${({ theme }) => theme['-ds-font-size-xxl']['font-size'].value};
`

const TitleWrapper = styled.div`
  font-size: ${({ theme }) => theme['-ds-font-size-sm']['font-size'].value};
  font-weight: 400;
  line-height: 1.5;
  margin-bottom: 8px;
`

const MessageWrapper = styled.div`
  font-size: ${({ theme }) => theme['-ds-font-size-xs']['font-size'].value};
  font-weight: 300;
  line-height: 1.3;
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  padding-left: 20px;
`

const Outer = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme['-ds-core-100'].value};
  padding: 30px 20px;
  border-radius: 8px;
  text-align: left;
`

const WaveEmoji = () => <Emoji emoji="👋" ariaLabel="waving-hand" />

type WarningCardProps = {
  title: ReactNode
  message: ReactNode
  iconography?: ReactNode
}

const WarningCard: FC<WarningCardProps> = ({
  iconography = <WaveEmoji />,
  title,
  message,
}) => {
  return (
    <Outer>
      <IconographyWrapper>{iconography}</IconographyWrapper>
      <TextWrapper>
        <TitleWrapper>{title}</TitleWrapper>
        <MessageWrapper>{message}</MessageWrapper>
      </TextWrapper>
    </Outer>
  )
}

export default WarningCard
